// extracted by mini-css-extract-plugin
module.exports = {"TicketHistoryContainer":"TicketHistory_TicketHistoryContainer__3FIuz","TicketHistoryTitle":"TicketHistory_TicketHistoryTitle__3Sgt3"};